import React, { useEffect } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { getUserAttribute, UserAttributes } from "shared-auth";
import { parseQuery } from "shared/utils/http";
import { UserManager } from "core";

function withArtistRef<P>(
  WrappedComponent: React.ComponentType<React.PropsWithChildren<P>>
): React.FC<React.PropsWithChildren<P>> {
  return (props) => {
    const location = useLocation();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const edit = searchParams.get("edit");
    const { artistref } = parseQuery(location.search);

    useEffect(() => {
      const performerId = getUserAttribute(UserAttributes.UserIdPerformer);

      UserManager.artistRef = performerId || artistref || UserManager.artistRef;

      if (artistref) {
        searchParams.delete("artistref");

        navigate(
          {
            pathname: location.pathname,
            search: edit ? searchParams.toString() : "",
          },
          { replace: true }
        );
      }
    }, [artistref, location.pathname, edit]);

    return <WrappedComponent {...props} />;
  };
}

export default withArtistRef;
